import { Component, OnInit, EventEmitter, Output, AfterViewInit } from '@angular/core';
import { VersionService } from '../version.service';

@Component({
    selector: 'app-main-footer',
    templateUrl: './main-footer.component.html',
    styleUrls: ['./main-footer.component.less'],
    standalone: false
})
export class MainFooterComponent implements OnInit, AfterViewInit {
  
  versaoNumero: string = '-';
  anoAtual: number = new Date().getFullYear();

  @Output()
  onViewInit: EventEmitter<any> = new EventEmitter();
  
  constructor(private versionService: VersionService) { }

  ngOnInit() {
    this.versionService.getVersion().subscribe(versionInfo => {
      this.versaoNumero = versionInfo.version;
    });
  }

  ngAfterViewInit(): void {
    this.onViewInit.emit();
  }

}
